var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "313px",
    height: "176px",
    viewBox: "0 0 313 176",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "component / spot image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 313,
    height: 176
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "3.47494013e-14 0 34 0 34 67 3.47494013e-14 67"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phase-2-Re-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About-us/-desktop",
    transform: "translate(-338.000000, -2269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "component-/-card-/-spot-illustration-+-brand-accent-copy",
    transform: "translate(338.000000, 2086.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "component-/-spot-image",
    transform: "translate(0.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "container"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84,33.5007645 C84,52.0018713 69.0018713,67 50.5007645,67 C31.9981287,67 17,52.0018713 17,33.5007645 C17,14.9981287 31.9981287,0 50.5007645,0 C69.0018713,0 84,14.9981287 84,33.5007645",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.499235,0 C97.9981287,0 83,14.9981287 83,33.5007645 C83,52.0018713 97.9981287,67 116.499235,67 C135.001871,67 150,52.0018713 150,33.5007645 C150,14.9981287 135.001871,0 116.499235,0 M116.499235,17.0026701 C125.596887,17.0026701 132.99733,24.4031128 132.99733,33.5007645 C132.99733,42.5968872 125.596887,49.9973299 116.499235,49.9973299 C107.403113,49.9973299 100.00267,42.5968872 100.00267,33.5007645 C100.00267,24.4031128 107.403113,17.0026701 116.499235,17.0026701 L116.499235,17.0026701",
    id: "Fill-6",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,33.5007645 C217,52.0018713 202.001871,67 183.500765,67 C164.998129,67 150,52.0018713 150,33.5007645 C150,14.9981287 164.998129,0 183.499235,0 C202.001871,0 217,14.9981287 217,33.5007645",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.499235,0 C229.998129,0 215,14.9981287 215,33.5007645 C215,52.0003423 229.998129,67 248.499235,67 C267.001871,67 282,52.0003423 282,33.5007645 C282,14.9981287 267.001871,0 248.499235,0 M248.499235,17.0026701 C257.596887,17.0026701 264.99733,24.4031128 264.99733,33.5007645 C264.99733,42.5968872 257.596887,49.9973299 248.499235,49.9973299 C239.403113,49.9973299 232.001141,42.5968872 232.001141,33.5007645 C232.001141,24.4031128 239.403113,17.0026701 248.499235,17.0026701",
    id: "Fill-10",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(348.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6369563,33.5007645 C67.6369563,52.0018713 52.4962433,67 33.8177064,67 C15.140713,67 3.47494013e-14,52.0018713 3.47494013e-14,33.5007645 C3.47494013e-14,14.9981287 15.140713,0 33.8177064,0 C52.4962433,0 67.6369563,14.9981287 67.6369563,33.5007645",
    id: "Fill-12",
    fill: "#000000",
    mask: "url(#mask-4)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.760e22c680049ae93077043f4ad650b6.svg";
export { ForwardRef as ReactComponent };